import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { canAccessSection } from "@/lib/permissions";

export default function SectionGuard({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!canAccessSection(user, pathname)) return <Navigate to="/dashboard" replace />;
  return children;
}
